import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@shared/translate/translate.service';
import { LoadingController } from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'any',
})
export class LoadingService {
  private _loading = inject(LoadingController);
  private _translate = inject(TranslateService);

  /**
   * Muestra un loading con el mensaje indicado
   * @param key Key de traduccion para mensaje a mostrar
   * @returns Promise con el loading creado
   */
  async show(key = 'xCargandoDatos') {
    const message = this._translate.instant(key);
    const loading = await this._loading.create({
      message,
      spinner: 'crescent',
    });
    await loading.present();
    return loading;
  }

  /**
   * Cierra el loading actual
   */
  async hide(loading: HTMLIonLoadingElement) {
    try {
      await loading.dismiss();
    } catch (error) {
      console.warn('Error cerrando loading:', error);
    }
  }
}
